module.exports = __webpack_public_path__ + "img/digital01_mo.b2ad6dbe.jpg";